import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ListCouponsComponent from '../../coupon/ListCouponsComponent';
import { COOKIE_KEY_MEMBER_KNOWN } from '../../../constants/cookie';
import { MERCHANTPAGE_COUPON_ANCHOR } from '../../../services/partner/constants';
import { getCoupons } from '../../../services/coupon/selector';
import { scrollToAnchor } from '../../../utils';

class CouponSectionComponent extends React.Component {
    componentDidMount() {
        this.scrollIfAnchored();
    }

    componentDidUpdate(prevProps) {
        const hadCoupons = prevProps.coupons && prevProps.coupons.length > 0;
        const hasCoupons = this.props.coupons && this.props.coupons.length > 0;

        if (!hadCoupons && hasCoupons) {
            this.scrollIfAnchored();
        }
    }

    // Fait défiler jusqu'à la section quand l'url porte son ancre : la section
    // n'existe qu'une fois les coupons chargés, le scroll est donc déclenché
    // ici (à l'apparition) et non au montage de la page.
    scrollIfAnchored = () => {
        if (window.location.hash === `#${MERCHANTPAGE_COUPON_ANCHOR}`) {
            scrollToAnchor(window.location);
        }
    };

    /**
     * On set un cookie pour les membres non loggés, non reconnu et qui n'ont pas deja le cookie COOKIE_KEY_MEMBER_KNOWN
     */
    onClickCoupon() {
        const { isAuthenticated, cookies } = this.props;
        if (!isAuthenticated && !cookies.get(COOKIE_KEY_MEMBER_KNOWN)) {
            cookies.set(COOKIE_KEY_MEMBER_KNOWN, 1, { path: '/' });
        }
    }

    render() {
        const { partnerId, partnerName, isAuthenticated, i18n, coupons, skipFirst } = this.props;
        // skipFirst : le premier code promo est déjà affiché dans l'en-tête
        const displayedCoupons = skipFirst && coupons ? coupons.slice(1) : coupons;
        if (displayedCoupons && displayedCoupons.length > 0) {
            return (
                <section id={MERCHANTPAGE_COUPON_ANCHOR}>
                    <h3>
                        {skipFirst
                            ? i18n.page.MERCHANTCARD.OTHER_DISCOUNT_TITLE
                            : i18n.page.MERCHANTCARD.DISCOUNT_TITLE}
                    </h3>
                    <ListCouponsComponent
                        coupons={displayedCoupons}
                        i18n={i18n}
                        partnerName={partnerName}
                        partnerId={partnerId}
                        isAuthenticated={isAuthenticated}
                        onItemClick={this.onClickCoupon.bind(this)}
                    />
                    <hr />
                </section>
            );
        }
        return null;
    }
}

CouponSectionComponent.propTypes = {
    partnerId: PropTypes.string.isRequired,
    partnerName: PropTypes.string.isRequired,
    skipFirst: PropTypes.bool
};

const mapStoreToProps = (state, ownProps) => ({
    coupons: getCoupons(state, ownProps.partnerId),
    i18n: state.i18n,
    isAuthenticated: state.authentication.isAuthenticated
});

export default connect(mapStoreToProps)(CouponSectionComponent);



// WEBPACK FOOTER //
// ./src/components/pages/merchantcard/CouponSectionComponent.js